<template>
  <Teleport :disabled="screenMinSm" :to="'#' + teleportSlotId">
    <Button
      class="back-button"
      :variant="screenMinSm ? 'secondary' : 'ghost'"
      :size="'large'"
      @click="emit('back-nav')"
    >
      <Icon name="chevron-left" />
      <span>{{ screenMinSm ? desktopBackTitle : 'Back' }}</span>
    </Button>
  </Teleport>
</template>

<script setup lang="ts">
import { screenMinSm } from '../utils/tallo-breakpoints.util';
import Button from './button/button.vue';
import Icon from './icon.vue';

const emit = defineEmits(['back-nav']);

withDefaults(
  defineProps<{
    teleportSlotId: string;
    desktopBackTitle?: string;
  }>(),
  {
    desktopBackTitle: 'Back',
  },
);
</script>

<style scoped lang="scss">
.back-button.back-button {
  width: fit-content;
  padding-left: 0;
}
</style>
